export const CLEAR_CART_ITEMS = 'CLEAR_CART_ITEMS';
export const CLEAR_CART_ITEMS_DONE = 'CLEAR_CART_ITEMS_DONE';
export const MODIFY_CART_ITEM = 'MODIFY_CART_ITEM';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const SET_CART_ITEM = 'SET_CART_ITEM';
export const SET_CART = 'SET_CART';
export const SET_CART_DONE = 'SET_CART_DONE';
